import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { cn } from '@/utils/cn.ts';

// Read-only render of a plaintext-email body (Markdown) — used in the content library.
// Uses react-markdown (escapes raw HTML by default, so no XSS surface) and the app's
// list/link formatting convention. `whitespace-pre-line` preserves the reading layout
// of legacy bodies whose paragraphs are separated by single newlines.
const MARKDOWN_CLASS = cn(
	'text-sm leading-relaxed whitespace-pre-line text-(--text-primary)',
	'[&_p]:my-2 [&_strong]:font-semibold [&_em]:italic',
	'[&_a]:text-(--color-beacon-accent) [&_a]:underline',
	'[&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-6',
	'[&_li]:leading-relaxed',
);

interface EmailBodyMarkdownProps {
	body: string;
	className?: string;
}

export const EmailBodyMarkdown = ({
	body,
	className,
}: EmailBodyMarkdownProps) => (
	<div className={cn(MARKDOWN_CLASS, className)}>
		<Markdown remarkPlugins={[remarkGfm]}>{body}</Markdown>
	</div>
);
